export const Action = {
  GET_USER_DATA: "GET_USER_DATA"
};

export const Mutation = {
  SET_USER: "SET_USER",
  SET_ORGANISATION: "SET_ORGANISATION",
  SET_SUBSCRIPTION: "SET_SUBSCRIPTION"
};

export const Getter = {
  // GET_USER: "GET_USER",
  // GET_ORGANISATION: "GET_ORGANISATION",
  // GET_OSUBSCRIPTION: "GET_SUBSCRIPTION",
  // USER_LOADED: "USER_LOADED"
};
